// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".cfeea88eb4920ad26e9ff3583cf00945.js";
};